<p-dialog header="{{ globalIdentifier.id ? ('fs.res.publication.GlobalIdentifier.dialog.edit'|hisUi) : ('fs.res.publication.GlobalIdentifier.dialog.add'|hisUi) }}" 
    [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false" [blockScroll]="true">

    <div class="layoutBlock">
        <div class="columnFullWidth">
            <his-plam>
                <p-autoComplete #content [hisDdKey]="'fs.res.publication.GlobalIdentifier.globalIdentifierType'"
                    [(ngModel)]="globalIdentifier.globalIdentifierType"
                    field="text"
                    appendTo="body"
                    [forceSelection]="true"
                    [dropdown]="true"
                    styleClass="autocompleteWidth100"
                    [suggestions]="filteredIdentifiers"
                    (completeMethod)="filterIdentifiers($event)">
                </p-autoComplete>
            </his-plam>
            <his-plam>
               <input #content [hisDdKey]="'fs.res.publication.GlobalIdentifier.identifier'" class="inputWidth100"
                    [(ngModel)]="globalIdentifier.identifier">
            </his-plam>
        </div>
    </div>
    
   <p-footer>
        <button (click)="applyChanges()" (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();">
            <span>{{ 'common.apply' | hisUi }}</span>
        </button>
        <button #cancelBtn (click)="closeDialog()" (keydown.tab)="$event.stopPropagation();">
            <span>{{ 'common.cancel' | hisUi }}</span>
        </button>
    </p-footer>
</p-dialog>